<template>
  <div v-if="hasContent" class="form__error-portal">
    <portal-target :name="portalName" multiple />
  </div>
</template>

<script>
import { Wormhole } from 'portal-vue';

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    portalName() {
      return `${this.name}-error`;
    },
    hasContent() {
      return Wormhole.getContentForTarget(this.portalName).length > 0;
    },
  },
};
</script>
